// Étape 7 (2026-11-02) : colonnes proposées à l'export (noms renvoyés par le serveur, get-export-columns).
// Mêmes traductions que les en-têtes des fichiers (Shared/Localization/ExportTexts.cs).
const exportEnColumns = {
  "Address": "Address",
  "Arrival Date": "Arrival Date",
  "Arrival Datetime": "Arrival Datetime",
  "Availability": "Availability",
  "Base Rate": "Base Rate",
  "Base Rate Return": "Base Rate Return",
  "Booked on": "Booked on",
  "Booking Class": "Booking Class",
  "Booking Ref No Offline": "Booking Ref No Offline",
  "Booking Ref No.": "Booking Ref No.",
  "Booking Type": "Booking Type",
  "Box Category Name": "Box Category Name",
  "Box Type Name": "Box Type Name",
  "Box Type Value": "Box Type Value",
  "Box Volume Name": "Box Volume Name",
  "Box Volume Value": "Box Volume Value",
  "Box Weight Value": "Box Weight Value",
  "Bus": "Bus",
  "Bus Brand": "Bus Brand",
  "Bus Model": "Bus Model",
  "Bus Name": "Bus Name",
  "Chassis No": "Chassis No",
  "City": "City",
  "ClientId": "ClientId",
  "Company Image URL": "Company Image URL",
  "Company Secret Key Set": "Company Secret Key Set",
  "Component Type": "Component Type",
  "Contact Email": "Contact Email",
  "Country": "Country",
  "Created On": "Created On",
  "Date": "Date",
  "Date Of Birth": "Date Of Birth",
  "Departure Date": "Departure Date",
  "Departure Datetime": "Departure Datetime",
  "Destination": "Destination",
  "Destination Name": "Destination Name",
  "Destination Station": "Destination Station",
  "Distance": "Distance",
  "Distance (km)": "Distance (km)",
  "Duration": "Duration",
  "Email": "Email",
  "First Name": "First Name",
  "Free Bags": "Free Bags",
  "Full Name": "Full Name",
  "Gender": "Gender",
  "Is SMS Notification Allowed": "Is SMS Notification Allowed",
  "IsActive": "IsActive",
  "Last Login": "Last Login",
  "Last Name": "Last Name",
  "Max Bags Allowed": "Max Bags Allowed",
  "Monetary Zone": "Monetary Zone",
  "Name": "Name",
  "No Of Rows": "No Of Rows",
  "No of Stations": "No of Stations",
  "No of Stops": "No of Stops",
  "No. of Baggage": "No. of Baggage",
  "No. of Booking": "No. of Booking",
  "No. of Bus": "No. of Bus",
  "No. of Passenger": "No. of Passenger",
  "No. of Shipment": "No. of Shipment",
  "No. of Trip": "No. of Trip",
  "Origin Station": "Origin Station",
  "Owner": "Owner",
  "OwnerId": "OwnerId",
  "Partner Name": "Partner Name",
  "Passenger Type": "Passenger Type",
  "Phone": "Phone",
  "Phone Number": "Phone Number",
  "Plan": "Plan",
  "Price": "Price",
  "Prix Bag": "Prix Bag",
  "Prix Bag Bike": "Prix Bag Bike",
  "Prix Bag Sup": "Prix Bag Sup",
  "Provider Interface": "Provider Interface",
  "Region": "Region",
  "Remarks": "Remarks",
  "Reporting Manager": "Reporting Manager",
  "Roles": "Roles",
  "Route Internal Code": "Route Internal Code",
  "Route Name": "Route Name",
  "Route Type": "Route Type",
  "Seating Model": "Seating Model",
  "Seating Model Name": "Seating Model Name",
  "Seating Model Ref": "Seating Model Ref",
  "Seating Type": "Seating Type",
  "Serial No": "Serial No",
  "Source": "Source",
  "Source Name": "Source Name",
  "Store": "Store",
  "Ticket Class": "Ticket Class",
  "Ticket Ref No Offline": "Ticket Ref No Offline",
  "Ticket Ref No.": "Ticket Ref No.",
  "TicketAmount": "TicketAmount",
  "Transport Vendor": "Transport Vendor",
  "Trip": "Trip",
  "Trip Name": "Trip Name",
  "Trip Reference Number": "Trip Reference Number",
  "Type": "Type",
  "User Remarks": "User Remarks",
  "Users": "Users",
};

export default exportEnColumns;
